import { render, staticRenderFns } from "./tenantMuti.vue?vue&type=template&id=822f87ca&"
import script from "./tenantMuti.vue?vue&type=script&lang=js&"
export * from "./tenantMuti.vue?vue&type=script&lang=js&"
import style0 from "./tenantMuti.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports